import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectRecipientsSummaryDomain = (state) =>
  state.get("recipientsSummary", initialState)

export const makeSelectSummary = () =>
  createSelector(selectRecipientsSummaryDomain, (state) => state.get("summary"))

export const makeSelectIsLoadingSummary = () =>
  createSelector(selectRecipientsSummaryDomain, (state) =>
    state.get("isLoadingSummary")
  )

export const makeSelectPercentage = () =>
  createSelector(selectRecipientsSummaryDomain, (state) =>
    state.get("percentage")
  )

const makeSelectRecipientsSummary = () =>
  createSelector(selectRecipientsSummaryDomain, (substate) => substate.toJS())

export default makeSelectRecipientsSummary
export { selectRecipientsSummaryDomain }
